import axios, { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { POST_OFFICE_BIG_LOGO, POST_OFFICE_SMALL_LOGO } from '@/constants';

interface UploadLogoPayload {
  file: string; // dataUrl
  contentType: string;
}

const dataUrlToBlob = (dataUrl: string, contentType: string): Blob => {
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1);
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: contentType });
};

export const useUploadOfficeSmallLogo = () =>
  useMutation<void, AxiosError, UploadLogoPayload>({
    mutationFn: ({ file, contentType }) =>
      axios
        .post(POST_OFFICE_SMALL_LOGO, dataUrlToBlob(file, contentType), {
          headers: { 'Content-Type': contentType },
        })
        .then((res) => res.data),
  });

export const useUploadOfficeBigLogo = () =>
  useMutation<void, AxiosError, UploadLogoPayload>({
    mutationFn: ({ file, contentType }) =>
      axios
        .post(POST_OFFICE_BIG_LOGO, dataUrlToBlob(file, contentType), {
          headers: { 'Content-Type': contentType },
        })
        .then((res) => res.data),
  });
